<template>
  <div class="login">
    <router-view/>
  </div>
</template>

<script>
export default {
}
</script> 
<style>
.title {
  font-weight: normal !important;
}
</style>
